var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper-container experience-swiper-loader"},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.range),function(i){return _c('div',{key:i,class:['swiper-slide', `swiper-slide-${i + 1}`]},[_c('LadExperienceCardLoader')],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }